import React from 'react'
import { Link } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import MessageUI from '../output/MessageUI'
import './IconButton.css'

const IconButtonLinkUI = ({messageList, icon, to, labelKey}) =>
  <Link className={`w_icon_btn icon ${icon}`} to={to}
    data-tip data-for={`t-${icon}`}>
    <ReactTooltip id={`t-${icon}`}>
      <MessageUI messageList={messageList} messageKey={labelKey} />
    </ReactTooltip>
  </Link>

export default IconButtonLinkUI
